export default "__VITE_ASSET__D5RZNqVy__"